<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="年" prop="year">
                    <el-date-picker v-model="queryCondition.year" value-format="yyyy" format="yyyy" type="year" placeholder="选择年" style="width:100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Category2" prop="category2CodesList">
                    <el-select v-model="queryCondition.category2CodesList" @change="changeCategory2" clearable multiple filterable placeholder="请选择(支持多选)" style="width:100%" class="multiple_sel">
                      <el-option v-for="item in categoryList2" :label="item.name" :value="item.code" :key="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Category3" prop="category3CodesList">
                    <el-select v-model="queryCondition.category3CodesList" clearable multiple filterable placeholder="请选择(支持多选)" style="width:100%" class="multiple_sel">
                      <el-option :key="index" v-for="(item,index) in categoryList3" :label="item.name" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="供应商集团名称" prop="groupName">
                    <el-input v-model="queryCondition.groupName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="计划月" prop="monthList">
                      <ic-select clearable table="TT_QSPI_QBR" field="MONTH" v-model="queryCondition.monthList" multiple placeholder="请选择(支持多选)" style="width:100%" class="multiple_sel"></ic-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="计划状态" prop="planStatus">
                      <ic-select clearable table="TT_QSPI_QBR" field="PLAN_STATUS" v-model="queryCondition.planStatus" style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="onSearch" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" @click="onMaintain">维护计划</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onExport">导出</el-button>
      </el-row>
      <ux-grid ref="plxTable" :data="tableData" @selection-change="selectionChange" @cell-click="cellClick" :cell-class-name='setCellClass' max-height="600" show-overflow="tooltip" highlight-current-row>
        <ux-table-column align="center" type="checkbox" width="80" />
        <!-- <ux-table-column align="center" title="序号" type="index" width="60" /> -->
        <ux-table-column align="center" title="年份" resizable min-width="80" field="year"></ux-table-column>
        <ux-table-column align="center" title="Category2" resizable min-width="120" field="category2Name"></ux-table-column>
        <ux-table-column align="center" title="供应商集团名称" resizable min-width="180" field="groupName"></ux-table-column>
        <ux-table-column align="center" title="供应商等级" resizable min-width="100" field="gradeI18n"></ux-table-column>
        <ux-table-column align="center" title="Min频率" resizable min-width="90" field="minFrequency"></ux-table-column>
        <ux-table-column align="center" title="Jan" resizable min-width="80" field="jan">
          <template v-slot="{ row }">
            <el-link :class="(row.janPlanStatus=='COMPLETED'||row.janPlanStatus=='CANCEL')?'qbr_link_fff':'qbr_link_000'" v-if="row.janPlanStatus=='IN_PLAN'||row.janPlanStatus=='DELAYED'||row.janPlanStatus=='COMPLETED'||row.janPlanStatus=='CANCEL'">{{row.jan}}</el-link>
            <p v-else>{{row.jan}}</p>
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="Feb" resizable min-width="80" field="feb">
          <template v-slot="{ row }">
            <el-link :class="(row.febPlanStatus=='COMPLETED'||row.febPlanStatus=='CANCEL')?'qbr_link_fff':'qbr_link_000'" v-if="row.febPlanStatus=='IN_PLAN'||row.febPlanStatus=='DELAYED'||row.febPlanStatus=='COMPLETED'||row.febPlanStatus=='CANCEL'">{{row.feb}}</el-link>
            <p v-else>{{row.feb}}</p>
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="Mar" resizable min-width="80" field="mar">
          <template v-slot="{ row }">
            <el-link :class="(row.marPlanStatus=='COMPLETED'||row.marPlanStatus=='CANCEL')?'qbr_link_fff':'qbr_link_000'" v-if="row.marPlanStatus=='IN_PLAN'||row.marPlanStatus=='DELAYED'||row.marPlanStatus=='COMPLETED'||row.marPlanStatus=='CANCEL'">{{row.mar}}</el-link>
            <p v-else>{{row.mar}}</p>
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="Apr" resizable min-width="80" field="apr">
          <template v-slot="{ row }">
            <el-link :class="(row.aprPlanStatus=='COMPLETED'||row.aprPlanStatus=='CANCEL')?'qbr_link_fff':'qbr_link_000'" v-if="row.aprPlanStatus=='IN_PLAN'||row.aprPlanStatus=='DELAYED'||row.aprPlanStatus=='COMPLETED'||row.aprPlanStatus=='CANCEL'">{{row.apr}}</el-link>
            <p v-else>{{row.apr}}</p>
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="May" resizable min-width="80" field="may">
          <template v-slot="{ row }">
            <el-link :class="(row.mayPlanStatus=='COMPLETED'||row.mayPlanStatus=='CANCEL')?'qbr_link_fff':'qbr_link_000'" v-if="row.mayPlanStatus=='IN_PLAN'||row.mayPlanStatus=='DELAYED'||row.mayPlanStatus=='COMPLETED'||row.mayPlanStatus=='CANCEL'">{{row.may}}</el-link>
            <p v-else>{{row.may}}</p>
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="Jun" resizable min-width="80" field="jun">
          <template v-slot="{ row }">
            <el-link :class="(row.junPlanStatus=='COMPLETED'||row.junPlanStatus=='CANCEL')?'qbr_link_fff':'qbr_link_000'" v-if="row.junPlanStatus=='IN_PLAN'||row.junPlanStatus=='DELAYED'||row.junPlanStatus=='COMPLETED'||row.junPlanStatus=='CANCEL'">{{row.jun}}</el-link>
            <p v-else>{{row.jun}}</p>
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="Jul" resizable min-width="80" field="jul">
          <template v-slot="{ row }">
            <el-link :class="(row.julPlanStatus=='COMPLETED'||row.julPlanStatus=='CANCEL')?'qbr_link_fff':'qbr_link_000'" v-if="row.julPlanStatus=='IN_PLAN'||row.julPlanStatus=='DELAYED'||row.julPlanStatus=='COMPLETED'||row.julPlanStatus=='CANCEL'">{{row.jul}}</el-link>
            <p v-else>{{row.jul}}</p>
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="Aug" resizable min-width="80" field="aug">
          <template v-slot="{ row }">
            <el-link :class="(row.augPlanStatus=='COMPLETED'||row.augPlanStatus=='CANCEL')?'qbr_link_fff':'qbr_link_000'" v-if="row.augPlanStatus=='IN_PLAN'||row.augPlanStatus=='DELAYED'||row.augPlanStatus=='COMPLETED'||row.augPlanStatus=='CANCEL'">{{row.aug}}</el-link>
            <p v-else>{{row.aug}}</p>
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="Sep" resizable min-width="80" field="sep">
          <template v-slot="{ row }">
            <el-link :class="(row.sepPlanStatus=='COMPLETED'||row.sepPlanStatus=='CANCEL')?'qbr_link_fff':'qbr_link_000'" v-if="row.sepPlanStatus=='IN_PLAN'||row.sepPlanStatus=='DELAYED'||row.sepPlanStatus=='COMPLETED'||row.sepPlanStatus=='CANCEL'">{{row.sep}}</el-link>
            <p v-else>{{row.sep}}</p>
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="Oct" resizable min-width="80" field="oct">
          <template v-slot="{ row }">
            <el-link :class="(row.octPlanStatus=='COMPLETED'||row.octPlanStatus=='CANCEL')?'qbr_link_fff':'qbr_link_000'" v-if="row.octPlanStatus=='IN_PLAN'||row.octPlanStatus=='DELAYED'||row.octPlanStatus=='COMPLETED'||row.octPlanStatus=='CANCEL'">{{row.oct}}</el-link>
            <p v-else>{{row.oct}}</p>
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="Nov" resizable min-width="80" field="nov">
          <template v-slot="{ row }">
            <el-link :class="(row.novPlanStatus=='COMPLETED'||row.novPlanStatus=='CANCEL')?'qbr_link_fff':'qbr_link_000'" v-if="row.novPlanStatus=='IN_PLAN'||row.novPlanStatus=='DELAYED'||row.novPlanStatus=='COMPLETED'||row.novPlanStatus=='CANCEL'">{{row.nov}}</el-link>
            <p v-else>{{row.nov}}</p>
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="Dec" resizable min-width="80" field="dec">
          <template v-slot="{ row }">
            <el-link :class="(row.decPlanStatus=='COMPLETED'||row.decPlanStatus=='CANCEL')?'qbr_link_fff':'qbr_link_000'" v-if="row.decPlanStatus=='IN_PLAN'||row.decPlanStatus=='DELAYED'||row.decPlanStatus=='COMPLETED'||row.decPlanStatus=='CANCEL'">{{row.dec}}</el-link>
            <p v-else>{{row.dec}}</p>
          </template>
        </ux-table-column>
      </ux-grid>
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount" :page-count="pages">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import store from '@/store/index'
import paginationMixin from '@/mixins/pagitionMixin';
import IcSelect from "@/components/common/icSelect";
import QBRApi from "@/api/QBR/index";
import commonFunction from "@/utils/dataTableUtils";
import { fileService } from "@/api/common/file-utils";
export default {
  name: 'qbrPlan',
  mixins: [paginationMixin],
  components: {
    IcSelect,
  },
  data() {
    return {
      categoryList2: [],
      categoryList3: [],
      tableData: [],
      multipleSelection: [],
      ttQspiQbrPlanIds: [],
      queryCondition: {
        year: '',
        category2CodesList: [],
        category3CodesList: [],
        groupName: "",
        monthList: [],
        planStatus: "",
        pageNum: 1,
        pageSize: 15,
      },
      isShow: false,
      formData: null,
      totalCount: 0,
      pages: 1,
    }
  },
  created() {
    console.log('new Date().getFullYear()', new Date().getFullYear().toString());
    this.queryCondition.year = new Date().getFullYear().toString()
    this.getCategory2Lists()
    this.getCategory3Lists()
  },
  watch: {
    queryCondition() {
      let _this = this;
      store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryCondition })
    }
  },
  beforeRouteEnter(to, from, next) {
    console.log("获取的参数===",to)
    if (!to.meta.reqData.year) {
      to.meta.reqData.year = new Date().getFullYear().toString()
    }
    if(to.query.category2CodesList){
      to.meta.reqData.category2CodesList=[]
      to.meta.reqData.category2CodesList.push(to.query.category2CodesList)
    }
    if(to.query.year){
      to.meta.reqData.year = to.query.year
    }
    console.log("查看页面总的参数====",to.meta.reqData)
    QBRApi.getQbrPlanLists(to.meta.reqData).then((res) => {
      next(vm => {
        console.log('to.meta.reqData',to.meta.reqData);
        vm.queryCondition = to.meta.reqData;
        vm.tableData = res.data.records;
        vm.totalCount = res.data.total;
      })
    })
  },
  methods: {
    queryData() {
      QBRApi.getQbrPlanLists(this.queryCondition).then(res => {
        this.tableData = res.data.records;
        this.totalCount = res.data.total;
        this.pages = res.data.pages;
        this.$refs.plxTable.reloadData(res.data.records)
      });
    },
    onSearch() {
      this.queryCondition.pageNum = 1
      this.queryCondition.pageSize = 15
      this.queryData()
    },
    getCategory2Lists() {
      var param = {
        categoryLevel: '2',
      }
      QBRApi.getCategoryLists(param).then(res => {
        this.categoryList2 = res.data
      });
    },
    //
    // selectable({ row }) {
    //   console.log('row',row);
    //   return !row.isDisabled
    // },
    getCategory3Lists() {
      var param = {
        categoryLevel: '3',
      }
      QBRApi.getCategoryLists(param).then(res => {
        this.categoryList3 = res.data
      });
    },
    //根据选中Category2查询Category3
    changeCategory2() {
      this.categoryList3 = []
      QBRApi.getCategoryLists({ categoryLevel: 3, category2Codes: this.queryCondition.category2CodesList }).then((res) => {
        this.categoryList3 = res.data;
      });
    },
    // 选中的行
    selectionChange(row) {
      console.log('row', row);
      this.ttQspiQbrPlanIds = []
      this.multipleSelection = row
      row.forEach(ele => {
        this.ttQspiQbrPlanIds.push(ele.ttQspiQbrPlanId)
      });
    },
    onMaintain() {
      console.log('this.ttQspiQbrPlanIds', this.ttQspiQbrPlanIds);
      if (this.ttQspiQbrPlanIds.length === 0) {
        this.$message.warning("请先选择数据后再操作")
        return false
      }
      // 为false可修改,true不可以维护
      var flag = this.multipleSelection.every(ele => {
        return !ele.isDisabled
      })
      if (!flag) {
        this.$message.warning("您无权维护此Category的QBR计划，请知悉.")
        return false
      }
      this.$router.push({
        path: "/qspiQBRPlan/detail",
        query: {
          ttQspiQbrPlanIds: JSON.stringify(this.ttQspiQbrPlanIds)
        }
      })
    },
    cellClick(row, column, cell, event) {
      // console.log('row', row);
      // console.log('column', column);
      // console.log('cell', cell);
      // console.log('event', event);
      var m = ''
      switch (column.property) {
        case "jan":
          m = '0' + 1
          break;
        case "feb":
          m = '0' + 2
          break;
        case "mar":
          m = '0' + 3
          break;
        case "apr":
          m = '0' + 4
          break;
        case "may":
          m = '0' + 5
          break;
        case "jun":
          m = '0' + 6
          break;
        case "jul":
          m = '0' + 7
          break;
        case "aug":
          m = '0' + 8
          break;
        case "sep":
          m = '0' + 9
          break;
        case "oct":
          m = '' + 10
          break;
        case "nov":
          m = '' + 11
          break;
        case "dec":
          m = '' + 12
          break;
      }
      if ((column.property == 'jan' && row.janPlanStatus) || (column.property == 'feb' && row.febPlanStatus) ||
        (column.property == 'mar' && row.marPlanStatus) || (column.property == 'apr' && row.aprPlanStatus) ||
        (column.property == 'may' && row.mayPlanStatus) || (column.property == 'jun' && row.junPlanStatus) ||
        (column.property == 'jul' && row.julPlanStatus) || (column.property == 'aug' && row.augPlanStatus) ||
        (column.property == 'sep' && row.sepPlanStatus) || (column.property == 'oct' && row.octPlanStatus) ||
        (column.property == 'nov' && row.novPlanStatus) || (column.property == 'dec' && row.decPlanStatus)) {
        this.$router.push({
          path: "/qspiQBR/detail",
          query: {
            ttQspiQbrPlanId: row.ttQspiQbrPlanId,
            month: row.year + '-' + m,
            from: "qbrPlan",
            year: row.year
          }
        })
      }
    },
    onReset() {
      this.$refs['queryCondition'].resetFields()
      this.queryCondition = {
        year: "",
        category2CodesList: [],
        category3CodesList: [],
        groupName: "",
        monthList: [],
        planStatus: "",
        pageNum: 1,
        pageSize: 15,
      }
      this.queryData();
    },
    onExport() {
      this.$set(this.queryCondition, 'ttQspiQbrPlanIds', this.ttQspiDqmpIdList)
      QBRApi.dqmpDownload(this.queryCondition).then(res => {
        fileService.respToFile(res, 'QSPI_QBR_Report.xlsx');
        this.ttQspiQbrPlanIds = []
        this.$refs['plxTable'].clearSelection()
      });
    },
    handleSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
    setCellClass({ row, column, rowIndex, columnIndex }) {
      // console.log('row', row);
      // console.log('column111', column);
      switch (column.property) {
        case 'jan':
          if (row.janPlanStatus === 'IN_PLAN') {
            return 'yellow_class'
          } else if (row.janPlanStatus === 'DELAYED') {
            return 'red_class'
          } else if (row.janPlanStatus === 'COMPLETED') {
            return 'green_class'
          } else if (row.janPlanStatus === 'CANCEL') {
            return 'gray_class'
          } else {
            return ''
          }
          break;
        case 'feb':
          if (row.febPlanStatus === 'IN_PLAN') {
            return 'yellow_class'
          } else if (row.febPlanStatus === 'DELAYED') {
            return 'red_class'
          } else if (row.febPlanStatus === 'COMPLETED') {
            return 'green_class'
          } else if (row.febPlanStatus === 'CANCEL') {
            return 'gray_class'
          } else {
            return ''
          }
          break;
        case 'mar':
          if (row.marPlanStatus === 'IN_PLAN') {
            return 'yellow_class'
          } else if (row.marPlanStatus === 'DELAYED') {
            return 'red_class'
          } else if (row.marPlanStatus === 'COMPLETED') {
            return 'green_class'
          } else if (row.marPlanStatus === 'CANCEL') {
            return 'gray_class'
          } else {
            return ''
          }
          break;
        case 'apr':
          if (row.aprPlanStatus === 'IN_PLAN') {
            return 'yellow_class'
          } else if (row.aprPlanStatus === 'DELAYED') {
            return 'red_class'
          } else if (row.aprPlanStatus === 'COMPLETED') {
            return 'green_class'
          } else if (row.aprPlanStatus === 'CANCEL') {
            return 'gray_class'
          } else {
            return ''
          }
          break;
        case 'may':
          if (row.mayPlanStatus === 'IN_PLAN') {
            return 'yellow_class'
          } else if (row.mayPlanStatus === 'DELAYED') {
            return 'red_class'
          } else if (row.mayPlanStatus === 'COMPLETED') {
            return 'green_class'
          } else if (row.mayPlanStatus === 'CANCEL') {
            return 'gray_class'
          } else {
            return ''
          }
          break;
        case 'jun':
          if (row.junPlanStatus === 'IN_PLAN') {
            return 'yellow_class'
          } else if (row.junPlanStatus === 'DELAYED') {
            return 'red_class'
          } else if (row.junPlanStatus === 'COMPLETED') {
            return 'green_class'
          } else if (row.junPlanStatus === 'CANCEL') {
            return 'gray_class'
          } else {
            return ''
          }
          break;
        case 'jul':
          if (row.julPlanStatus === 'IN_PLAN') {
            return 'yellow_class'
          } else if (row.julPlanStatus === 'DELAYED') {
            return 'red_class'
          } else if (row.julPlanStatus === 'COMPLETED') {
            return 'green_class'
          } else if (row.julPlanStatus === 'CANCEL') {
            return 'gray_class'
          } else {
            return ''
          }
          break;
        case 'aug':
          if (row.augPlanStatus === 'IN_PLAN') {
            return 'yellow_class'
          } else if (row.augPlanStatus === 'DELAYED') {
            return 'red_class'
          } else if (row.augPlanStatus === 'COMPLETED') {
            return 'green_class'
          } else if (row.augPlanStatus === 'CANCEL') {
            return 'gray_class'
          } else {
            return ''
          }
          break;
        case 'sep':
          if (row.sepPlanStatus === 'IN_PLAN') {
            return 'yellow_class'
          } else if (row.sepPlanStatus === 'DELAYED') {
            return 'red_class'
          } else if (row.sepPlanStatus === 'COMPLETED') {
            return 'green_class'
          } else if (row.sepPlanStatus === 'CANCEL') {
            return 'gray_class'
          } else {
            return ''
          }
          break;
        case 'oct':
          if (row.octPlanStatus === 'IN_PLAN') {
            return 'yellow_class'
          } else if (row.octPlanStatus === 'DELAYED') {
            return 'red_class'
          } else if (row.octPlanStatus === 'COMPLETED') {
            return 'green_class'
          } else if (row.octPlanStatus === 'CANCEL') {
            return 'gray_class'
          } else {
            return ''
          }
          break;
        case 'nov':
          if (row.novPlanStatus === 'IN_PLAN') {
            return 'yellow_class'
          } else if (row.novPlanStatus === 'DELAYED') {
            return 'red_class'
          } else if (row.novPlanStatus === 'COMPLETED') {
            return 'green_class'
          } else if (row.novPlanStatus === 'CANCEL') {
            return 'gray_class'
          } else {
            return ''
          }
          break;
        case 'dec':
          if (row.decPlanStatus === 'IN_PLAN') {
            return 'yellow_class'
          } else if (row.decPlanStatus === 'DELAYED') {
            return 'red_class'
          } else if (row.decPlanStatus === 'COMPLETED') {
            return 'green_class'
          } else if (row.decPlanStatus === 'CANCEL') {
            return 'gray_class'
          } else {
            return ''
          }
          break;
      }
    },

  },
  extends: commonFunction
}
</script>
<style scoped >
</style>
